import { useRequest } from 'ahooks';
import { getPolicyTimelineMindmap } from '../../../axios/api'

function useGetPolicyTimelineMindmap(){
  const {  data:policyTimelineMindmapData, loading:policyTimelineMindmapLoading,runAsync:getPolicyTimelineMindmapAction } = useRequest(
    async (params) => {
      try {
        const resp = await getPolicyTimelineMindmap({
          ...params
        });
        return resp?.data ?? undefined
      } catch (error) {
        return undefined;
      }
    },
    {
      debounceWait: 1,
      manual: true,
    },
  );

    return {
      policyTimelineMindmapData,
      policyTimelineMindmapLoading,
      getPolicyTimelineMindmapAction
    
    }
}

export default useGetPolicyTimelineMindmap